import { useLocation } from "react-router-dom";

const SITE_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const OG_IMAGE = `${SITE_URL}/og-image.jpg`;

export const Seo = ({ title, description, noindex = false }) => {
  const { pathname } = useLocation();
  const url = `${SITE_URL}${pathname === "/" ? "/" : pathname}`;
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Central Air Depot" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content="1264" />
      <meta property="og:image:height" content="848" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
    </>
  );
};
